import { Link } from "react-router-dom";
import { ArrowRight, Building2, Home, Stethoscope, Droplets, ScanLine, Microscope, GraduationCap, Network, Briefcase } from "lucide-react";
import { Reveal, Stagger, StaggerItem } from "../components/Reveal";
import CTABand from "../components/CTABand";
import PageMeta from "../components/PageMeta";

const INDUSTRIES = [
  { icon: Building2, title: "Hospitals", line: "Multi-department equipment, furniture and infrastructure coordination for new and expanding hospitals." },
  { icon: Home, title: "Nursing Homes", line: "Complete ward, OT and ICU setups scaled to your facility." },
  { icon: Stethoscope, title: "Clinics", line: "Examination, procedure and day-care equipment for clinical practice." },
  { icon: Droplets, title: "Dialysis Centres", line: "Machines, chairs, RO plants and consumables as one coordinated setup." },
  { icon: ScanLine, title: "Diagnostic Centres", line: "Imaging, ECG, monitoring and lab equipment for diagnostic workflows." },
  { icon: Microscope, title: "Laboratories", line: "Microscopes, analyzers and lab consumables with workflow planning." },
  { icon: GraduationCap, title: "Medical Institutions", line: "Training and institutional equipment programmes." },
  { icon: Network, title: "Healthcare Chains", line: "Standardised multi-site procurement and support." },
  { icon: Briefcase, title: "Corporate Healthcare Facilities", line: "Workplace clinics and corporate health infrastructure." },
];

const Industries = () => (
  <main data-testid="industries-page">
    <PageMeta title="Industries We Serve | AccuSurge Medical Solutions" description="Hospitals, nursing homes, clinics, dialysis centres, diagnostic centres, laboratories, medical institutions, healthcare chains and corporate healthcare facilities." />
    <section className="bg-brand-950 pb-20 pt-40 md:pb-28 grain relative overflow-hidden">
      <div className="container-x relative">
        <Reveal>
          <span className="eyebrow text-accent">Industries We Serve</span>
          <h1 className="mt-6 max-w-4xl font-heading text-4xl md:text-6xl font-semibold tracking-tighter text-white">
            Solutions for Every Healthcare Setting.
          </h1>
        </Reveal>
      </div>
    </section>

    <section className="py-20 md:py-28">
      <div className="container-x">
        <Stagger className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {INDUSTRIES.map((ind) => (
            <StaggerItem key={ind.title}>
              <div className="group h-full rounded-xl border border-slate-200 bg-white p-8 transition-all duration-300 hover:-translate-y-1 hover:border-brand-300 hover:shadow-[0_20px_40px_rgba(0,0,0,0.06)]" data-testid={`industry-card-${ind.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-brand-50 text-brand-600 transition-colors group-hover:bg-accent group-hover:text-white">
                  <ind.icon className="h-6 w-6" />
                </span>
                <h2 className="mt-6 font-heading text-xl font-semibold text-ink">{ind.title}</h2>
                <p className="mt-3 text-sm leading-relaxed text-slate-600">{ind.line}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
        <Reveal className="mt-14 flex flex-wrap gap-4">
          <Link to="/contact" className="btn-accent">Discuss Your Requirement <ArrowRight className="h-4 w-4" /></Link>
          <Link to="/products" className="btn-outline">Browse Products</Link>
        </Reveal>
      </div>
    </section>

    <CTABand />
  </main>
);

export default Industries;
